export default function getEnvironment() {
	switch (window.location.host) {
		case 'developer.aptopayments.com':
			return 'PRD';
		case 'developer.stg.aptopayments.com':
		default:
			return 'STG';
	}
}
